import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import PreviewPageErrorBoundary from "./PreviewPageErrorBoundary";
const Preview = React.lazy(() => import('../Preview/index'));

function PreviewPage(props){
  return (
      <>
        <div className="row options-header">
          <div className="col three-outer-cont">
            <Suspense fallback={<div>Loading...</div>}>
              <Preview
                pieceType={PIECE_TYPE}
                meshName={PIECE_SIZE}
                color={PIECE_MATERIAL}
                threeParams={CHART_3D_PARAMS}
              />
            </Suspense>
          </div>
        </div>
      </>
  );
}

function PreviewPageWithErrorBoundary(props){

  return (<PreviewPageErrorBoundary>
    <PreviewPage {...props} />
  </PreviewPageErrorBoundary>)
}

export default PreviewPageWithErrorBoundary;
